<template>
    <div>
        
        <h6 class="heading-small text-muted mb-4">LICENSE MANAGER</h6>
        
        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <base-alert v-if="messages != null" type="success">
            {{messages}}
        </base-alert>

        <form>
            <div class="row">
                <div class="col-lg-12">
                    <base-input alternative=""
                                label="System Name"
                                input-classes="form-control"
                                v-model="inputSystemName"
                                disabled
                               
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <base-input alternative=""
                                label="Terminal Name"
                                input-classes="form-control"
                                v-model="inputTerminalName"
                                disabled
                               
                    />
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6">
                    <base-input alternative=""
                                label="Company Name"
                                input-classes="form-control"
                                v-model="inputCompanyName"
                                disabled
                               
                    />
                </div>
                <div class="col-lg-6">
                    <base-input alternative=""
                                label="Module Name"
                                input-classes="form-control"
                                v-model="inputModuleName"
                                disabled
                               
                    />
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6">
                    <!-- <base-input alternative=""
                                label="Expiration Date"
                                input-classes="form-control"
                                v-model="inputExpiration"
                               
                    /> -->
                    <base-input alternative="" label="Expiration Date">
                        <br><a-date-picker v-model="inputExpiration" :format="dateFormat" input-classes="form-control"/>
                    </base-input>
                </div>
                <div class="col-lg-6">
                    <!-- <base-input alternative=""
                                label="Activated Date"
                                input-classes="form-control"
                                v-model="inputActivation"
                                disabled
                               
                    /> -->
                    <base-input alternative="" label="Activation Date">
                        <br><a-date-picker v-model="inputActivation" placeholder="Unactivated" :format="dateFormat" input-classes="form-control" disabled/>
                    </base-input>
                </div>
            </div>

            <div class="row">
                <div class="col-lg-6">
                    <base-input alternative="" label="Version">
                        <a-select v-model="inputVersion" input-classes="form-control" :disabled="this.inputLicenseKey != null">
                            <a-select-option v-for="option in versions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                        </a-select>
                    </base-input>
                </div>
            </div>

            <hr class="my-4" />
            <h6 class="heading-small text-muted mb-4">License</h6>
            <div class="row">
                <div class="col-lg-12">
                    <base-input alternative=""
                                label="License Key"
                                input-classes="form-control"
                                v-model="inputLicenseKey"
                                disabled       
                    />
                </div>
            </div>
            <span class="account-type-container">
                <div class="account-label-container">
                    Billing Type :
                </div>
                <a-select
                    v-model="selectedBillingType"
                    style="width: 65%"
                    @change="handleChange(accountId)">
                    <a-select-option  v-for="(billing_type, index) in billingTypes"
                        :key="index"
                        :value="billing_type.id">
                        {{ billing_type.name }}
                    </a-select-option>
                </a-select>
            </span>
        </form>

        <div style="position: absolute; bottom: 0px;right: 0px; width: -webkit-fill-available; background-color: #f2f2f2 ;padding: 10px;">
            <button v-if="inputLicenseKey == null" type="button" class="btn btn-success float-right" @click.prevent="generateLicenseKey">Generate License</button>
            <div v-else>
                <a-popconfirm title="Are you sure you want to revoke the license of this terminal?" @confirm="revokeLicenseKey" okText="Revoke" cancelText="Cancel">
                    <a class="btn btn-danger float-right text-white">Revoke License</a>
                </a-popconfirm>
                <a-popconfirm title="Are you sure you want to regenerate the license of this terminal?" @confirm="generateLicenseKey" okText="Regenerate" cancelText="Cancel">
                    <a class="btn btn-success float-right text-white mr-2">Regenerate License</a>
                </a-popconfirm>
            </div>
       </div> 

    </div>
</template>


<script>
import axios from "axios";
import HTTPRequest from '../../../controllers/httpRequest.js'
import { mapState } from 'vuex'
import secureStorage from '../../../controllers/secureStorage';
import moment from 'moment';

var component_x;
export default {
    computed: {
        ...mapState(['endPoint', 'profileId']),
    },
    data: function(){
        return {
            accountId: null,
            inputSystemName: "Barter XI",
            inputModuleName: "POS",
            inputCompanyName: "iRipple, Inc.",
            inputTerminalName: "",
            inputLicenseKey: null,
            inputActivation: "",
            inputExpiration: "",
            inputVersion: "5.0",
            dateFormat: 'MM-DD-YYYY',
            errors: [],
            messages: null,
            billingTypes:[],
            currentTerminalID:null,
            selectedBillingType:'',
            // is_ordertaker_spm: false,
            terminalSettings: {},
            versions: [
                { id: "5.0", name: "Barter POS Version 5.0" },
                { id: "5.1", name: "Barter FPOS 5.1" }
            ]
        }
    },
     methods: {
        revokeLicenseKey(){
            axios({
            method: 'delete',
            url: this.endPoint + 'licenses/' + this.inputTerminalName  + "?field_name=terminal_code&account_id=" + this.accountId,
            headers: {
              Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
              "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-Web"
            },
          })
          .then(async function() {
            // console.log(data)
            var license_data = await HTTPRequest.getRequest(component_x.endPoint + 'licenses/' + component_x.inputTerminalName  + "?field_name=terminal_code&account_id=" + component_x.accountId, null) 
            if(license_data["error"] == undefined){
                component_x.inputLicenseKey = license_data["license_key"]
            } else {
                component_x.inputExpiration = null
                component_x.inputLicenseKey = null
                component_x.messages = "Successfully revoked license"
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
            }
          })
          .catch(function(e) {
            alert(e)
          });
        },
        async generateLicenseKey(){
            this.terminalSettings["is_ordertaker_spm"] = this.is_ordertaker_spm
            var licensePayload = {
                license: {
                    terminal_code: this.inputTerminalName,
                    module: this.inputModuleName,
                    company: this.inputCompanyName,
                    expiry_date: this.inputExpiration,
                    version: this.inputVersion
                },
                terminal_setting: {
                    terminal_id: this.terminalSettings["id"],
                    is_ordertaker_spm: this.is_ordertaker_spm
                }
            }
            // var licensePayload = { license: {terminal_code: this.inputTerminalName, module: this.inputModuleName, company: this.inputCompanyName, expiry_date: this.inputExpiration}}
            var post_request = await HTTPRequest.postRequest(this.endPoint + 'licenses?account_id=' + this.accountId, null, licensePayload)   
            if(post_request == undefined){
                // this.$router.go(-1)
            } else {
               if(post_request["error"] == undefined){
                   var license_data = await HTTPRequest.getRequest(this.endPoint + 'licenses/' + this.inputTerminalName  + "?field_name=terminal_code&account_id=" + this.accountId, null) 
                   if(license_data["error"] == undefined){
                    this.inputLicenseKey = license_data["license_key"]
                    component_x.messages = "Successfully generated license"
                    component_x.errors = []
                    document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                   }  
                } else {
                    this.errors = []
                    this.errors.push(post_request["error"])
                    component_x.messages = null
                    document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                }
            } 

        },
        async getBillingTypes(){
          this.billingTypes = await HTTPRequest.getRequest(`${this.endPoint}/billing_types`, null, null) 
        },
        async handleChange(id){
          let params = { 'billing_type_id': this.selectedBillingType , 'account_id': this.accountId }
          await HTTPRequest.putRequest(`${this.endPoint}/terminals/${this.currentTerminalID}`, null, params) 
        },
    },
    mounted: async function(){
        component_x = this;
        this.accountId = this.$attrs.accountId
        this.inputTerminalName = ""
        // var terminal_data = await HTTPRequest.getRequest(this.endPoint + 'terminals/' + this.profileId + "?account_id=" + this.accountId, null)    
        this.getBillingTypes();
        var terminal_data = await HTTPRequest.getRequest(this.endPoint + 'terminals/' + this.profileId + "?account_id=" + this.accountId, null)
        this.selectedBillingType = terminal_data.billing_type_id === null ? '' : terminal_data.billing_type_id
        this.currentTerminalID = terminal_data.id
        var terminal_code = terminal_data["code"]
        this.inputTerminalName = terminal_code
        // console.log(terminal_data)
        if(terminal_code != undefined){
            var license_data = await HTTPRequest.getRequest(this.endPoint + 'licenses/' + terminal_code  + "?field_name=terminal_code&account_id=" + this.accountId, null)    
            if(license_data == undefined){
                this.inputLicenseKey = null
            } else {
                if(license_data["error"] == undefined){
                    this.inputLicenseKey = license_data["license_key"]
                    this.inputActivation = license_data["activation_date"] == null ? license_data["activation_date"] : moment(license_data["activation_date"])
                    this.inputExpiration = moment(license_data["expiry_date"])
                    this.inputVersion = license_data["version"]
                } else {
                    this.inputLicenseKey = null
                    // alert(license_data["error"])
                    // component_x.$router.push("/")
                } 
            }
        }

    }
}
</script>

<style>
.account-type-container {
  display: flex;
  align-items: center;
}
.account-label-container{
  font-weight: bold;
  margin-right: 5px;
}
</style>